import PensionEntitiesView from "../PensionEntitiesView.vue";
import PensionEntityList   from "../Pages/PensionEntityList.vue";
import PensionEntityEditor from "../Pages/PensionEntityEditor.vue";

const routes = [
  {
    path: "/mantenimiento/entidades-pensionarias",
    component: PensionEntitiesView,
    children: [
      {
        path: "",
        name: "pension-entity-list",
        component: PensionEntityList,
      },
      {
        path: "crear",
        name: "pension-entity-create",
        component: PensionEntityEditor,
      },
      {
        path: ":id/editar",
        name: "pension-entity-edit",
        component: PensionEntityEditor,
      },
    ],
  },
];

export default routes;
